import { Injectable } from '@angular/core';
import { ReferenceNavigasi } from '../../../models/master-user/reference-navigasi.model';
import { Adapter } from '../adapter.service';

@Injectable({
  providedIn: 'root',
})
export class ReferenceNavigasiAdapter implements Adapter<ReferenceNavigasi> {
  public adapt(item: any): ReferenceNavigasi {
    return {
      id: item.idReferenceNavigation,
      nama: item.nama,
      url: item.urlSuperApp,
      navigasi: {
        id: item.idNavigation,
        nama: item.nav,
      },
      newTab: Number(item.newTab) === 1,
      tipeKlinik: item.typeKlinik,
      add: item.add,
      edit: item.edit,
      delete: item.delete,
      modulSuperApp: item.modulSuperApp,
      urlSuperApp: item.urlSuperApp,
      namaNavigasi: item.nav,
      addOnClinic: item.fromAddon,
      status: item.status,
      idReferenceNavigationHead: item.idReferenceNavigationHead,
      subActions: item.subActions || [],
    };
  }
}
